module.exports = __webpack_public_path__ + "img/profile.0c7184b4.png";